import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'moment/locale/pt-br';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { PersistGate } from 'redux-persist/integration/react';

//import { ThemeProvider } from '@material-ui/core/styles';
//import { PersistGate } from 'redux-persist/integration/react';

import './config/ReactotronConfig';
import Routes from './routes';
import history from './services/history';
import { store, persistor } from './store';
import GlobalStyle from './styles/global';
import ThemeCustom from './styles/theme';

import { useCheckVersion } from './hooks/useCheckVersion';

moment.locale('pt-br');

export default function App() {
  useCheckVersion();
  return (
    <Provider store={store}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <PersistGate persistor={persistor}>
          <Router history={history}>
            <ThemeProvider theme={ThemeCustom}>
              <Routes />
              <GlobalStyle />
              <ToastContainer enableMultiContainer autoClose={3000} />

              <ToastContainer
                enableMultiContainer
                autoClose={99999}
                containerId="second"
                position="bottom-left"
                style={{ width: '50%' }}
              />
            </ThemeProvider>
          </Router>
        </PersistGate>
      </MuiPickersUtilsProvider>
    </Provider>
  );
}
